<script setup lang="ts">



import DxButton from 'devextreme-vue/button';
import DxSelectBox from 'devextreme-vue/select-box';
import { DxCheckBox } from 'devextreme-vue/check-box';
import DxValidator, {
  DxRequiredRule,
  DxPatternRule,
  DxCompareRule
} from 'devextreme-vue/validator';
import validationEngine from "devextreme/ui/validation_engine";
import { DxTabPanel, DxItem as DxTabItem } from 'devextreme-vue/tab-panel';
import { DxTextBox, DxButton as DxTextBoxButton } from 'devextreme-vue/text-box';
import { DxTagBox } from 'devextreme-vue/tag-box';




import { ref, onMounted, watch, onBeforeMount, computed } from "vue";
import GroupButtonParams from '../components/GroupButtonParams.vue'
import ComplectList from '../components/ComplectList.vue'
import { useCalcBuildingStore } from "../store/useCalcBuildingStore";
import TagBasket from '../components/TagBasket.vue'
import userIcon from '../assets/userFigma.svg'
import phoneIcon from '../assets/phoneFigma.svg'
import telegramIcon from '../assets/telegram-icon.svg'
import whatsupIcon from '../assets/whatsapp-icon.svg'
import phoneContactIcon from '../assets/phone-contact-icon.svg'
import mailIcon from '../assets/mailIcon.svg'
import DescriptionTab from '../components/descriptionTab.vue'
import DeliveryTab from '../components/deliveryTab.vue'



const comagicIsSend = ref(false)
const currentImageIndex = ref(0);

function checkComparison() {
  return true;
}
const images = computed(() => {
  const template = $buildingStore.article.imageTemplate;
  return [template.mainImageUrl, ...template.extraImageUrls];
});
const nextImage = () => {
  currentImageIndex.value = (currentImageIndex.value + 1) % images.value.length;
};

const prevImage = () => {
  currentImageIndex.value = (currentImageIndex.value - 1 + images.value.length) % images.value.length;
};

const $buildingStore = useCalcBuildingStore();

const tagBox = ref(null)
const divTest = ref(null)
const imagePath = 'https://evrazsteelbox.ru/local/templates/evrazsteelbox/images/lk-site/articleimages/'
const mainDiv = ref(null);
const phonePattern = ref(/^[01-9]\d{9}$/);
const defaultValueCity = ref();
const avaibleConsultation = ref(false)
onBeforeMount(() => {
  console.log("before calcVue")
})
const readyData = $buildingStore.fetchInitData()
onMounted(() => {

  readyData.then(() => {
    
    var pathArr = 'zdanie-sbornoe'//window.location.pathname.split("/").filter(x=>x.length>1).slice(-1)[0]
    const basket = $buildingStore.fetchBasket()
    basket.then((result) => {
      var art
      if (result) {
        art = basket
      } else {
        art = $buildingStore.fetchArticleTemplateByName(pathArr)
      }
      const initArticleRespones = art
      if (initArticleRespones) {
        initArticleRespones.then(() => {
          const defCity = $buildingStore?.cities?.find((x: { environmentId: any; }) => x.environmentId == $buildingStore.article.params?.environmentId)?._id;
          defaultValueCity.value = defCity;
          //defaultValueCity.value = $buildingStore.cities.find(x=> x.city=='Москва')._id//$buildingStore.article.params?.environmentId
          $buildingStore.tagBoxRef = tagBox.value;
          $buildingStore.changeCardParams("environmentId", $buildingStore.article.params?.environmentId);
          initDefaultParams();

        })

      }
    })
  })
})

watch(
  () => $buildingStore.links.cartCardPath,
  () => {
    $buildingStore.ifr ? $buildingStore.basketRef = $buildingStore.links.cartCardIFramePath : $buildingStore.basketRef = $buildingStore.links.cartCardPath
  }
)

watch(
  () => tagBox.value,
  (newValue) => {

    $buildingStore.tagBoxRef = newValue;

  }
);



function initDefaultParams() {
  readyData.then(() => {
    //await $buildingStore.fetchInitData()
    initDefaultParam($buildingStore.article.params, "length")
    initDefaultParam($buildingStore.article.params, "width")
    initDefaultParam($buildingStore.article.params, "height")
    //checkRelations('width', $buildingStore.article.params.width)
  })
}

async function initDefaultParam(params: any, dim: string) {
  readyData.then(() => {
    const paramValue = params[dim];
    $buildingStore.changeCardParams(dim, paramValue);

  })
}


const goBasket = () => {
  document.location = $buildingStore.basketRef;
}
const addItemInBasket = () => {
  $buildingStore.addItemInBasket($buildingStore.article);
}
const onValueCityChanged = (e: any) => {
  const envId = $buildingStore.cities.find((x: { _id: any; }) => x._id == e.value).environmentId
  $buildingStore.changeCardParams("environmentId", envId);
}

const sendConsultationForm = () => {
  // console.log($buildingStore.miniBasket)
  // console.log($buildingStore.userData)
$buildingStore.addLog($buildingStore.nameText, $buildingStore.phoneText)
  const validationResultPerson = validationEngine.validateGroup("consultationValidation");
  const isValid = validationResultPerson.isValid
  if (isValid){
     //@ts-ignore
    ym(87107319,'reachGoal','box20zakaz')
    //console.log('reach goal box20')  
  const xhr = new XMLHttpRequest();
  xhr.open("POST", "https://evrazsteelbox.ru/local/ajax/manager_form.php");
  xhr.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
  const body = JSON.stringify({
    name: $buildingStore.nameText,
    phone: $buildingStore.phoneText,
  });
  xhr.onload = () => {
    if (xhr.readyState == 4 && xhr.status == 200) {
      //console.log(xhr.responseText);
       //@ts-ignore
      Comagic.setProperty('Форма', 'Создать заказ ЛК');
       //@ts-ignore
      Comagic.addOfflineRequest({
        form_name: "SB2.0 Запросить консультацию у менеджера",
        name: $buildingStore.nameText,
        phone: $buildingStore.phoneText,

        message: xhr.responseText,
        // message: parseInt(arrPhp['result_id']).toString(),
      });
      //console.log(JSON.parse(xhr.responseText));
    } else {
    //  console.log(JSON.parse(xhr.responseText));
      //console.log(`Error: ${xhr.status}`);
    }
  };
  xhr.send(body);
  comagicIsSend.value = true;
}

}
const basketCount = computed(() => {
  return $buildingStore.miniBasket.length ? $buildingStore.miniBasket.length.toString() : ""
})
const userButton = {
  icon: userIcon,
  stylingMode: 'text',
  disabled: true

};

const phoneButton = {
  icon: phoneIcon,
  text:'+7',
  stylingMode: 'text',
  disabled: true

};


const consultCheckBoxChanged =((e:any)=>{
  avaibleConsultation.value = e.value

})

const hasDependenciesOfType = (type: string): boolean => {
      return $buildingStore.article.dependencies.some((dependency: { tabType: string }) => dependency.tabType === type);
    };
</script>

<template>
  <div v-if="!$buildingStore.managerIdCheck">
    Не удалось определить id менеджера
  </div>
  <div v-if="!$buildingStore.bpmIdCheck">
    Не удалось определить пользователя
  </div>
  <div style="width:min-content;" class="general-card-block color-grey" ref="divTest"
    v-if="$buildingStore.pageIsFounded && $buildingStore.dataIsInit && $buildingStore.bpmIdCheck && $buildingStore.managerIdCheck">
    <div v-if='$buildingStore.ifr' style="margin-bottom:4px">
      <span class="main-heading">{{ $buildingStore.article.headerTitle }}</span>
      <div class="basket-class" style="width:100%; height: fit-content;">
        <div class="square-button" style="margin-bottom: 10px; margin-right: 20px;" @click="goBasket">
          <i class="dx-icon-cart" style="font-size: 20px;"></i>
          <span v-if="basketCount" class="basket-count">{{ basketCount }}</span>
        </div>
        <DxTagBox class="tagBox" ref="tagBox" :data-source="$buildingStore.miniBasket" value-expr="guidItem"
          display-expr="title" :value="$buildingStore.idBasket" :read-only="true" styling-mode="underlined"
          placeholder="" tag-template="tag">

          <template #tag="{ data }">
            <TagBasket :tag-data="data" />
          </template>
        </DxTagBox>


      </div>
    </div>
    <div v-else style="margin-bottom:12px; margin-top: 12px;">
      <span class="main-heading">{{ $buildingStore.article.headerTitle }}</span>
    </div>

    <div class="" style="width:100%;">

      <div ref="mainDiv" class="esb-flex-row-center">
        <div v-if="$buildingStore.articleIsFounded" class="esb-flex-col-start img-block" style="max-width: 500px;">
          
            <div class="esb-flex-row-center" style="width:100%;">
              <div class="favorite-sign">
                <img src="/src/assets/star.svg" style="width: 1rem;" />
                <span>Не требуется разрешение на строительство</span>
              </div>
            </div>

            <!-- Главное изображение с кнопками -->
            <div class="main-image-wrapper">
              <img class="main-img"
                :src="`${imagePath}${$buildingStore.article.imageTemplate.name}/${images[currentImageIndex]}`" />

              <!-- Кнопки -->
              <button class="nav-button left" @click="prevImage">
                <span class="nav-button-content">&#10094;</span></button>
              <button class="nav-button right" @click="nextImage">

                <span class="nav-button-content">&#10095;</span>
              </button>
            </div>

            <!-- Превью -->
            <div class="esb-flex-row-center">
              <div v-for="(img, index) in images" :key="index"
                :class="['thumbnail-wrapper', { active: currentImageIndex === index }]"
                @click="currentImageIndex = index" style="width: 100%; margin-right: 8px; cursor: pointer;">
                <img class="main-img" :src="`${imagePath}${$buildingStore.article.imageTemplate.name}/${img}`" />
              </div>
            </div>
         

          <!-- Когда статья не найдена -->
          <div v-if="!$buildingStore.articleIsFounded" style="width: 100%;">
            <img style="width: 100%;" class="main-img" src="/src/assets/notFinded.png" />
          </div>
          <div v-if="$buildingStore.articleIsFounded && false" class="gost-main-article bottom">
            <span>
              Артикул {{ $buildingStore.article.articleCode }}
            </span>
          </div>
        </div>

        <div class="color-white" style=" min-width: 400px; margin-left: 1.5rem; margin-right: 1.5rem;">
          <div style="margin: 1.5rem;" class="esb-flex-col-start wrapclass">
            <GroupButtonParams title="Ширина пролета, м" type="width" />

            <GroupButtonParams title="Длина, м" type="length" />

            <GroupButtonParams title="Высота, м" type="height" />

            <div v-if="false" style="width: 100%;" class="location-block"></div>
            <div v-if="false" style="text-align: left;margin-top: 1rem;" class="location">Климатическое исполнение для
              вашего региона</div>

            <div v-if="false" style="width: 100%;">
              <DxSelectBox class="custom-select" placeholder="Выберите район" :data-source="$buildingStore.cities"
                value-expr="_id" display-expr="city" :value="defaultValueCity" styling-mode="outlined"
                @value-changed="onValueCityChanged" :buttons="[
                  {
                    name: 'location',
                    location: 'before',
                    options: {
                      icon: 'location',
                      stylingMode: 'text',
                      disabled: true
                    }
                  }
                ]" />
            </div>

          </div>
        </div>
        <div style="" class="price-info-block esb-flex-col-start">

          <div class="price-flex">
            <div class="price-wrapper">
              <div class="main-price"><span>{{ $buildingStore.article.formatedPrices.priceWithDiscount }}</span></div>
              <div class="nds"><span>(с НДС)</span></div>
            </div>
            <div class="red-price">
              <span>
                НОВИНКА!
              </span>
            </div>
          </div>

          <div style="width:100%" v-if='$buildingStore.ifr'>
            <div v-if="$buildingStore.checkFrame()">
              <button :disabled="!$buildingStore.article.prices.priceIsFounded" class="add-button"
                :focusStateEnabled="false" @click="$buildingStore.switchFrames()">ЗАМЕНИТЬ В КОРЗИНЕ</button>
            </div>
            <div v-else>
              <button
                :disabled="!$buildingStore.article.prices.priceIsFounded || $buildingStore.getDisabled('frame').value"
                class="add-button" :focusStateEnabled="false" @click="addItemInBasket">ДОБАВИТЬ В КОРЗИНУ</button>
            </div>
          </div>
          <div class="contact-widgets">
            <div class="contact-widgets-row">
              <div>
                <a href="https://api.whatsapp.com/send/?phone=%2B79692688420&text&type=phone_number&app_absent=0"
                  class=""><img class="contact-img" :src="whatsupIcon" alt="whatsapp"></a>
              </div>
              <div>
                <a href="tel:88003006559" class="tel-text"><img class="contact-img" :src="phoneContactIcon"
                    alt="whatsapp"><span>{{$buildingStore.telephone}}</span></a>
              </div>
            </div>
            <div class="contact-widgets-row">
              <div>
                <a href="https://t.me/EvrazSmallBox_bot" class=""><img class="contact-img" :src="telegramIcon"
                    alt="telegram"></a>
              </div>
              <div>
                <a href="mailto:sales.box2@evrazsteel.ru" class="tel-text"><img class="contact-img" :src="mailIcon"
                    alt="mail"><span>sales.box2@evrazsteel.ru</span></a>
              </div>
            </div>
          </div>

          <!-- <div style="margin-top: 3rem;" v-if="false && $buildingStore.articleIsFounded"
            class="d-flex  align-content-between mb-3">
            <div class="d-flex flex-column align-items-center justify-content-center" style="flex:1;">
              <i class="dx-icon-taskcomplete icon-warehouse" style="font-size: 20px;"> </i>
              <span class="font-warehouse">Гарантия<br>качества</span>
            </div>
            <div class="d-flex flex-column align-items-center border-delivery-warhouse" style="flex:1;">
              <span class="icon-warehouse">Под заказ</span>
              <span class="font-warehouse">Ближайшая<br>дата доставки</span>
            </div>
            <div class="d-flex flex-column align-items-center justify-content-between" style="flex:1;">
              <DxButton class="icon-warehouse" styling-mode="text" icon="cart" :focusStateEnabled="false"
                @click="goBasket" />
              <span class="font-warehouse">Перейти<br>в корзину</span>
            </div>
          </div> -->

          <div v-if='!comagicIsSend' class="consultation-div color-white">
            <div class="consultation-inputs">

              <DxTextBox width="100%" placeholder="Ваше имя" v-model="$buildingStore.nameText" styling-mode="outlined"
              >
                <DxTextBoxButton :options="userButton" name="userName" location="before" />
                <DxValidator validation-group="consultationValidation">
                      <DxRequiredRule message="Заполните имя" />

                    </DxValidator>
              </DxTextBox>


              <DxTextBox width="100%" placeholder="Введите телефон" v-model="$buildingStore.phoneText" mask="(000) 000-00-00" styling-mode="outlined"  maskInvalidMessage="Введите корректный телефон"
             >
                <DxTextBoxButton :options="phoneButton" name="userPhone" location="before" />
              
                <DxValidator validation-group="consultationValidation">
                      <DxPatternRule :pattern="phonePattern" message="Введите корректный телефон" />
                      <DxRequiredRule message="Заполните телефон" />

                    </DxValidator>
              </DxTextBox>


            </div>
            <div class='consultation-policy-div'>
              <div class='consultation-policy' style="text-align: left">
                <DxCheckBox height="13px" @value-changed="consultCheckBoxChanged" validation-message-position="bottom"
                validation-message-mode="always">

                  <DxValidator validation-group="consultationValidation">
              <DxCompareRule
                :comparison-target="checkComparison"
                message="Необходимо согласие на обработку персональных данных"
              />
            </DxValidator>
                </DxCheckBox>
                <span class="confirm-element confirm-text">Я согласен на
                  <span style="color:#9E9E9E">обработку персональных данных</span></span>
              </div>
     


            </div>
            <DxButton  class="send-button" style="margin-top: 1rem;" :focusStateEnabled="false" styling-mode="text"
              @click="sendConsultationForm">
              <template #content="{}">
                <div class="contentButtonSend"><span>Уточните комплектацию</span>
                  <span>у менеджера</span>
                </div>
              </template>
            </DxButton>
          </div>

          <div v-else class="consultation-div color-white text-consultation-reply" style="text-align: start;">
            <p>Запрос успешно отправлен. Благодарим за интерес к решениям EVRAZ STEEL BOX!
               В ближайшее время мы с вами свяжемся, чтобы обсудить все детали.</p>
          </div>
        </div>
      </div>
    </div>

    <div class="complect-div color-white">

      <div class="complect-title">
        <span>
          Собрать комплект
        </span>

      </div>
      <div v-if="$buildingStore.article.dependencies.length > 0">
        <DxTabPanel :animation-enabled="true" :focus-state-enabled="false" :show-nav-buttons="true"
          styling-mode="secondary">
          <DxTabItem
            v-if="hasDependenciesOfType('set')"
            title='Рекомендованные комплекты'>
            <ComplectList tabType="set" />
          </DxTabItem>
          <DxTabItem
            v-if="false && hasDependenciesOfType('roof')"
            title='Сэндвич-панели кровельные'>
            <ComplectList tabType="roof" />
          </DxTabItem>
          <DxTabItem
            v-if="false && hasDependenciesOfType('walls')"
            title='Сэндвич-панели стеновые'>
            <ComplectList tabType="walls" />
          </DxTabItem>
          

          <DxTabItem
            v-if="hasDependenciesOfType('extras')"
            title='Дополнительная комплектация'>
            <ComplectList tabType="extras" />
          </DxTabItem>
          
        </DxTabPanel>
      </div>
      <div>
        <DxTabPanel :animation-enabled="true" :focus-state-enabled="false" :show-nav-buttons="true"
          styling-mode="secondary">

          <DxTabItem title='Описание'>
            <DescriptionTab/>

          </DxTabItem>
          <DxTabItem v-if="false" title='Документы'>
            <!-- <div class="tab-item" style="height: 500px;"><span>Здесь будут документы</span>
              <div class="certificates__item swiper-slide">
                <a href="https://evrazsteelbox.ru/upload/docs/7.1-MSS-38489.pdf" target="_blank" download
                  class="certificates__item-file">
                  <img style="height: 400px;" alt="certificate"
                    src="https://evrazsteelbox.ru/upload/docs/images/7.1-MSS-38489.jpg">
                </a>
              </div>
            </div> -->



          </DxTabItem>

          <DxTabItem title='Доставка'>
            <DeliveryTab />
          </DxTabItem>
        </DxTabPanel>
      </div>
    </div>
  </div>
</template>

<style scoped>
.text-consultation-reply{
  color: #212529;
    font-weight: 400;
    font-size: 16px;
    line-height: 120%;
}
.esb-flex-col-start {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.img-block {
  gap: 10px
}

.esb-flex-row-center {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.complect-div {

  padding-top: 32px;
  padding-right: 34px;
  padding-bottom: 32px;
  padding-left: 34px;

  display: flex;
  flex-direction: column;
  gap: 10px
}

.general-card-block {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.tel-text {
  font-weight: 500;
  font-size: 18px;
  line-height: 120%;
  letter-spacing: 0.16px;
  vertical-align: middle;
  color: #0A0A0A;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 5px
}

.contact-img {
  height: 28px;
  width: 28px;
}

.contact-widgets {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.contact-widgets-row {
  gap: 30px;
  display: flex;
  flex-direction: row;
  margin-left: 20px;
}

.contentButtonSend {
  display: flex;
  flex-direction: column;
  line-height: 1
}

.price-info-block {
  gap: 20px;
  justify-content: space-between;
  width: 441px;
  max-width: 441px;
  min-width: 441px;
}

.price-flex {
  display: flex;
  gap: 40px;
  justify-content: space-between;
  width:100%;
}

.price-wrapper {
  display: flex;
  gap: 10px;
  align-items: flex-end;
}

.complect-title {
  display: flex;
  font-weight: 500;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: 0.16px;
  vertical-align: middle;
  color: #0A0A0A
}

.consultation-policy-div {
  display: flex;
  align-items: center;

}

.consultation-policy {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.confirm-text {
  white-space: nowrap;
  color: #0A0A0A;

  font-weight: 400;
  font-size: 10px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: middle;

}



.consulatation-header {
  font-size: 18px;
  font-weight: 500;
  color: #0A0A0A;
  line-height: 110%;
  letter-spacing: 0%;
  white-space: nowrap;
}

.basket-class {
  display: flex;
  margin-top: 10px;
  align-items: flex-end;
}

.main-heading {
  display: flex;
  font-size: 32px;
  font-weight: 500;
  line-height: 120%;
  vertical-align: middle;
  letter-spacing: 0%;
  color: #0A0A0A;
}


.location {

  line-height: 110%;
  word-wrap: break-word;
  white-space: normal;
  width: 240px;

}

.red-price {
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0%;
  line-height: 120%;
  background-color: #e53935;
  color: white;

  padding-top: 11px;
  padding-bottom: 11px;
  padding-left: 28px;
  padding-right: 28px;
  border-radius: 4px;

}

.location-block {
  border-top: 1px solid #E0E0E0;
  margin-top: 1rem;
  padding-top: 1.5rem;


}

.input-wrapper {
  display: flex;
  align-items: center;
  border: 1px solid #aaa;
  border-radius: 8px;
  padding: 6px 12px;
  background-color: #fff;
}



.input-icon {
  margin-right: 8px;
  display: flex;
  align-items: center;
}

.input-icon img {
  width: 20px;
  height: 20px;
  opacity: 0.6;
}

.custom-input {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  width: 100%;
}

.main-img {
  width: 100%;

  height: auto;
  object-fit: contain;

}

.main-image-wrapper {
  position: relative;
  width: 100%;
  height: 240px;
}

.nav-button {
  position: absolute;
  top: 40%;
  transform: translateY(-50%);
  background-color: rgba(255, 255, 255, 0.7);
  border: 1px solid #ccc;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  font-size: 1.5rem;
  font-weight: bold;
  color: #000;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.9;
  transition: background-color 0.2s, opacity 0.2s;
}

.nav-button:hover {
  background-color: #e0e0e0;
  opacity: 1;
}

.nav-button.left {
  left: -30px;
  clip-path: inset(0 0 0 50%);
}

.nav-button.left .nav-button-content {

  right: 15px;
  position: absolute;
  font-size: 14px;
}

.nav-button.right {
  right: -30px;
  clip-path: inset(0 50% 0 0);
}

.nav-button.right .nav-button-content {

  left: 15px;
  position: absolute;
  font-size: 14px;
}

.thumbnail-wrapper.active {
  border: 2px solid #ED7818;
  padding: 2px;
  position: relative;
}

.thumbnail-wrapper {
  height: 46px;
  position: relative;
}

/* .thumbnail-wrapper.active::after {
  content: "";
  position: absolute;
  right: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #ED7818;
  bottom: -12px;

}

.thumbnail-wrapper::after {
  content: "";
  position: absolute;
  right: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: grey;
  bottom: -12px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  border-bottom-right-radius: unset;
  border-bottom-left-radius: unset;
} */




::v-deep(.dx-icon-location) {
  background: url('https://evrazsteelbox.ru/local/templates/location.svg') no-repeat center center;
  background-size: contain;
  width: 1.25rem;
  /* 20px */
  height: 1.25rem;
  display: inline-block;
  /* transform: translateY(-0.125rem); */
}




.tagBox::after {
  border-bottom-width: 0px !important;
  width: fit-content
}

.bottom {
  margin-top: auto;
}



.parent-vertical {
  display: flex;
  flex-direction: column;
  height: 100%;
}



.favorite-sign {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 500;
  justify-content: center;
  /* text-align: center; */

  font-size: 16px;
  letter-spacing: 0.16px;
  line-height: 120%;
  color: #E02F2F;
  width: 100%;

  white-space: nowrap;


  gap: 10px;
  border-radius: 4px;
  border-width: 1px;
  padding-top: 4px;
  padding-right: 34px;
  padding-bottom: 4px;
  padding-left: 34px;
  border: 1px solid #E0E0E0
}


/* .html { */
/* font-size: 24px; */

/* } */
.gost-main-article {
  text-align: start;
  width: 100%;
  color: #9E9E9E;
  font-weight: 400;
  font-size: 14px;
  line-height: 110%;
  letter-spacing: 0%;

}

.tab-item {
  height: 200px;
  text-align: left;
  margin-top: 16px;
}

.wrapclass {
  display: flex !important;
  flex-wrap: wrap !important;
  /* ВАЖНО! */
  gap: 0.5rem !important;
}

.buttongroups-container {
  display: flex;
  justify-content: flex-start;
  font-size: 16px;
  margin: 8px
}



.discount-price {
  font-size: 28px;
  color: #e53935;
  font-weight: bold;
}



.percent-discount {
  background-color: #e53935;
  color: white;
  border-radius: 5px;

  font-weight: bold;
}

.color-grey {
  background-color: #f9f9f9;
}

.color-white {
  background-color: #FFFFFF;
}

.best-price-label {

  border-radius: 5px;
}

.gap-big {
  gap: 1.875rem;
}

.confirm-label {
  margin-top: 12px;
  text-align: left;
}

.confirm-element {
  vertical-align: middle;
}

.without-discount-price {
  font-weight: bold;
  font-size: 16px;
  text-decoration: line-through
}

.article-title {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;

  text-align: end;
}



.font-warehouse {
  font-size: 14px;
  line-height: 110%;
  font-weight: 400;
  letter-spacing: 0%;
}



.text-input-consulation {
  height: 30px;
  font-size: 13px;
}

.icon-warehouse {
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 100%;
  letter-spacing: 0%;
  color: #595959;

}

.border-delivery-warhouse {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
  justify-content: space-between;
}

.consultation-div {
  display: flex;
  gap: 10px;
  flex-direction: column;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 8px;
  padding-left: 8px;
  width:100%;
}

.consultation-inputs {
  display: flex;
  gap: 10px
}

.consulation-button {
  width: 100%;
  color: grey
}



.square-button {
  border: 1px solid #ddd;
  border-radius: 0.5rem;
  width: 2rem;
  /* Ширина кнопки */
  height: 2rem;
  /* Высота кнопки */
  background-color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  /* Центрирование иконки по вертикали */
  justify-content: center;
  /* Центрирование иконки по горизонтали */
  padding: 0;
  position: relative;
}

.basket-count {
  position: absolute;
  top: -5px;
  right: -10px;
  background-color: #e53935;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8rem;
}

.square-button .dx-icon {

  font-size: 2.25rem;
  /* Размер иконки (по необходимости можно увеличить) */
  width: 100%;
  /* Иконка растягивается по ширине кнопки */
  height: 100%;
  /* Иконка растягивается по высоте кнопки */
  display: flex;
  align-items: center;
  /* Центрирование иконки по вертикали */
  justify-content: center;
  /* Центрирование иконки по горизонтали */
}

.square-button:hover {
  background-color: lightgray;
}

.bottom-left {
  grid-area: bottom-left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}

.main-price {
  color: #E02F2F;

  font-weight: 500;
  font-size: 36px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;

  white-space: nowrap;
}

.old-price-row {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  color: #555;
}

.old-price {
  text-decoration: line-through;
  font-size: 16px;
  line-height: 120%;
  font-weight: 500;
  letter-spacing: 0.16px;
  color: #0A0A0A
}

.nds {
  font-size: 18px;
  color: #9E9E9E;

  font-weight: 500;
  line-height: 110%;
  letter-spacing: 0%;
  white-space: nowrap;
}

.bottom-right {
  grid-area: bottom-right;
  display: flex;
  align-items: stretch;
}


.send-button {
  background-color: #f57c00;
  color: white;
  font-size: 14.6px;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  padding: 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
  white-space: nowrap;
  height: 100%;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  width: 100%;
}

.add-button {
  background-color: #f57c00;
  color: white;
  padding: 0.75rem 1.5rem;
  font-size: 14.6px;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: 0%;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
  white-space: nowrap;
  height: 100%;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  width: 100%;
}

.add-button:disabled {
  background-color: rgba(0, 0, 0, .1);
  color: lightgray;
  pointer-events: none;
}
</style>
